var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('transition',{attrs:{"name":"opacity-fade"}},[_c('modal-base',{attrs:{"post":_vm.modalPost},on:{"increment":() => _vm.$emit('increment'),"decrement":() => _vm.$emit('decrement'),"close":dontShow => _vm.$emit('close', dontShow)}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }